import { Navigate } from "react-router-dom";

import { ReactNode, useContext } from "react";
import AuthContext from "../context/auth/context";

const RequireAuth = ({ children }: { children: ReactNode }) => {
  const { isAuthenticated } = useContext(AuthContext);

  return isAuthenticated ? <>{children}</> : <Navigate to={"/login"} replace />;
};
export default RequireAuth;
